import { Grid2 as Grid, styled } from "@mui/material";

export const FullWidthGrid = styled(Grid)(() => ({
  width: "100%",
  height: "100%",
}));
export const SubjectGridItem = styled(Grid)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.grey[400]}`,
}));
export const OperatorGridItem = styled(Grid)(({ theme }) => ({
  borderRight: `1px solid ${theme.palette.grey[400]}`,
  minWidth: "80px",
}));
export const ValueGridItem = styled(Grid)(({ theme }) => ({
  borderTopRightRadius: `${theme.shape.borderRadius}px !important`,
  borderBottomRightRadius: `${theme.shape.borderRadius}px !important`,
  overflow: "hidden",
}));
